import React, { useState, useEffect } from 'react';
import Modal from '../../../shared/Modal';
import uploadStore from './UploadStore';
import { Button, Dimmer, Loader, Form, Icon, Checkbox, TextArea, Input } from 'semantic-ui-react';
import ModalConfirm from '../../Modal/ModalConfirm'
import './../../DragDrop.scss';
import { action } from 'mobx';
import DragDropFile from './../../DragDropFile';
import { observer } from 'mobx-react';

function UploadPaperwork(props) {
  const { 
    open, 
    modalParams, 
    submitDocumentType, 
    attachmentType_Paperwork, 
    toggleModal, 
    submitFileHandler 
  } = uploadStore;

  const { serviceType, id, label } = modalParams;
  const [uploadFile, setUploadFile] = useState([]);
  const [otherLink, setOtherLink] = useState('');
  const [otherLink2, setOtherLink2] = useState('');
  const [emailtoDoctor, setemailtoDoctor] = useState(false);
  const [openModalConfirm, setOpenModalConfirm] = useState(false)
  const [askedsendMail, setAskedSendEmail] = useState(false)
  const title = () => {
    return label + ' - Upload Paperwork: ' + modalParams.caseNo + ' - Claimant: ' + modalParams.claimant;
  };

  const onSubmitFile = action(() => {
    uploadStore.loading = true;
    if (!uploadFile || uploadFile.length <= 0) {
      return;
    }

    if (!emailtoDoctor && !askedsendMail) {
      uploadStore.loading = false;
      return setOpenModalConfirm(true)
    }

    var uploadAttachment = [];
    uploadFile.forEach(element => {
      uploadAttachment.push(
        {
          [`${serviceType}Id`]: id,
          FileName: element.name,
          Title: element.title,
          ReportType: element.reportType,
          Type : element.reportType,
          NumberOfPages: element.numberOfPages
        }
      );
    });
    const uploadData = {
      [`${serviceType}Id`]: id,
      ReportType: attachmentType_Paperwork[serviceType],
      [`${serviceType}Attachment`]: uploadAttachment,
      Otherlink: otherLink,
      SendPaperWork: emailtoDoctor,
      Token: modalParams.token,
      Type: modalParams.type,
    }
    if (serviceType !== 'Assessment') {
      uploadData['Otherlink2'] = otherLink2;
    }
    submitFileHandler(
      modalParams.token ? submitDocumentType['IME_Paperwork_Onetimeacess'] : submitDocumentType[serviceType],
      uploadData,
      props.refetchTable);
  });

  const onUploadFile = (acceptedFiles, reportType) => {
    if (acceptedFiles != null) {
      acceptedFiles.forEach(function (element) {
        element.reportType = reportType;
      });
      const data = [...uploadFile, ...acceptedFiles].filter((v, i, a) => a.findIndex(t => (t.name === v.name)) === i);
      setUploadFile(data);
    }
  };

  const onDeleteFile = (deletedFiles) => {
    if (deletedFiles != null) {
      const data = [...uploadFile].filter(x => x.name !== deletedFiles.name);
      setUploadFile(data);
    }
  };

  const handleEmailConfirm = () => {
    setemailtoDoctor(true)
    setAskedSendEmail(true)
  }

  useEffect(() => {
    askedsendMail && onSubmitFile();
    // eslint-disable-next-line
  }, [askedsendMail])

  return (
    <React.Fragment>
      <Modal
        visible={open}
        onCancel={toggleModal(false)}
        width={600}
        className='custom-modal'
        title={title()}
        footer={
          <React.Fragment>
            <Button color="blue" disabled={!uploadFile || uploadFile.length === 0} onClick={onSubmitFile} loading={uploadStore.loading}>
              <Icon name="upload" /> Upload
            </Button>
            <Button color="red" onClick={toggleModal(false)}>
              <Icon name="close" /> Close
            </Button>
          </React.Fragment>
        }
      >
        <Dimmer active={uploadStore.loading}>
          <Loader />
        </Dimmer>
        <Form >
          <Form.Group inline>
            <Form.Field >
              <label >Email Paperwork to Specialist</label>
            </Form.Field>
            <Form.Field >
              <Checkbox
                checked={emailtoDoctor}
                onChange={() => setemailtoDoctor(!emailtoDoctor)} />
            </Form.Field>
          </Form.Group>
          {serviceType !== 'Assessment' && (
            <Form.Field >
              <label >Share Download Link (for LOI)</label>
              <Input
                placeholder="Share Download Link (for LOI)"
                className="text-area"
                name="otherLink"
                value={otherLink}
                onChange={(_, { value }) => setOtherLink(value)}
              />
            </Form.Field>
          )}
        </Form>

        <div style={{ marginTop: "10px" }}>
          <DragDropFile
            onUploadFile={onUploadFile}
            onDeleteFile={onDeleteFile}
            type={attachmentType_Paperwork[serviceType]}
            title="Letter of Instruction (LOI)"
            accept='application/pdf'
            maxSize='50'
          />
          <hr></hr>
        </div>

        <Form >
          {serviceType === 'Assessment' &&
          (
            <Form.Field >
              <label >Share Download Links (for Other Documents)</label>
              <TextArea
                placeholder="Share Download Links (for Other Documents)"
                className="text-area"
                name="otherLink"
                value={otherLink}
                onChange={(_, { value }) => setOtherLink(value)}
              />
            </Form.Field>
          )}
        </Form>

        {serviceType === 'Assessment' && 
        <div style={{ marginTop: "10px" }}>
          <DragDropFile
            onUploadFile={onUploadFile}
            onDeleteFile={onDeleteFile}
            type={attachmentType_Paperwork.Assessment_Other}
            title="Other Documents"
            maxSize='50' />
          <hr />
        </div>}
        
        {serviceType !== 'Assessment' && 
        (
          <React.Fragment>
            <Form >
              <Form.Field >
                <label >Share Download Links (for Original Reports)</label>
                <TextArea
                  placeholder="Share Download Links (for Original Reports)"
                  className="text-area"
                  name="otherLink2"
                  value={otherLink2}
                  onChange={(_, { value }) => setOtherLink2(value)}
                />
              </Form.Field>
            </Form>

            <div style={{ marginTop: "10px" }}>
              <DragDropFile
                onUploadFile={onUploadFile}
                onDeleteFile={onDeleteFile}
                type={attachmentType_Paperwork[`${serviceType}_Other`]}
                title="Original Reports"
                maxSize='50' />
              <hr></hr>
            </div>
          </React.Fragment>
        )}
      </Modal>
      <ModalConfirm
        modalParams={{
          message:'Do you want to send paperwork to Specialist now ?',
          onOk : () => handleEmailConfirm()
        }}
        open={openModalConfirm}
        onCancel={() => {
          setOpenModalConfirm(false);
          setAskedSendEmail(true);
        }}
        hideWarningIcon
      />
    </React.Fragment>
  );
}

export default observer(UploadPaperwork);
